import dayjs from 'dayjs';

import { HistoryData } from 'api/useFetchBulkHistory';

import { Card, Stack, Text } from '@mantine/core';

import { getItemModText } from './helpers';

type ConfirmUndoProps = {
  lastUpdate: HistoryData;
};

export default function ConfirmUndo({ lastUpdate }: ConfirmUndoProps) {
  return (
    <Stack>
      <Text>
        Are you sure you want to undo this update made on{' '}
        <Text span variant="body-sm-bold">
          {dayjs(lastUpdate.timestamp).format('MMMM D, YYYY')}
        </Text>
        ?
      </Text>
      <Card p="sm" bg="var(--surface-secondary)">
        <Text>
          {lastUpdate.detail} {getItemModText(lastUpdate.type)}
        </Text>
      </Card>
      <Text>Please note this will only undo bulk price updates, not individual price updates.</Text>
    </Stack>
  );
}
